import React from 'react'
import {
  Icon,
  Popup,
  SemanticCOLORS,
  SemanticICONS
} from 'semantic-ui-react'
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon'

/**
 * Provides a component for that renders an encounter detail header icon
 * @param name Icon name
 * @param size Icon size. Default large
 * @param popup Popup text. Default: null
 * @param color Icon color. Default: grey
 * @param onClick On click callback function
 * @param disabled Default: false
 */

type Props = {
  name: SemanticICONS
  size: IconSizeProp | undefined
  popUp: string
  color: SemanticCOLORS | undefined
  onClick: () => void
  isDisabled: boolean
}

function HeaderIcon(
  props: Props
): JSX.Element {
  const {
    name,
    size = 'large',
    popUp,
    color = 'grey',
    onClick,
    isDisabled
  } = props
  if (isDisabled) {
    return (
      <Icon
        name={ name }
        disabled
        size={ size }
        color={ color }
      />
    )
  }
  if (popUp) {
    return (
      <Popup
        content={ popUp }
        mouseEnterDelay={ 800 }
        trigger={
          <Icon
            name={ name }
            size={ size }
            color={ color }
            onClick={ onClick }
            className="pointer"
          />
        }
      />
    )
  }
  return (
    <Icon
      name={ name }
      size={ size }
      color={ color }
      onClick={ onClick }
      className="pointer"
    />
  )
}

export default HeaderIcon
